import React, { Component } from 'react'
import classnames from 'classnames'
import wrapperClickOutside from '../../../components/shared/wrapper-click-outside'

import {
    friendshipStateLookup,
    setStatus as setStatusFunc,
} from './helpers'

import {
    withRouterConnectWrapper,
    i18n,
} from '../../../validator'
import SportnectionsRequestButton from './buttons/request'
import SnIcon from '../shared/sn-icon'
import Button from '../shared/sn-button'

/**
 * Render dropdown button
 *
 * @param props -
 *          toggleDropdown => function for toggle
 *          dropdown => is dropdown showing?
 *          children => dropdown content rows
 * @returns {XML}
 * @constructor
 */
export const Dropdown = props => (
    <div className="Sportnections__search-row-dropdown">
        <div className="Sportnections__search-row-dropdown-button" onClick={props.toggleDropdown}>
            <div className={classnames({
                'Sportnections__search-row-dropdown-button-down': !props.dropdown,
                'Sportnections__search-row-dropdown-button-up': props.dropdown,
            })}
            />
        </div>

        {props.dropdown &&
            <div className="Sportnections__search-row-dropdown-container">
                {props.children}
            </div>
        }
    </div>
)

@i18n()
class FriendshipStatus extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loader: false,
            dropdown: false,
        }
    }

    /**
     * Toggle dropdown menu
     */
    toggleDropdown = () => {
        this.setState({ dropdown: !this.state.dropdown })
    }

    /**
     * Set friendship status to specific user
     *
     * @param {Integer} actualStatus
     * @param {Integer} newStatus
     * @param {string} confirmMessage
     * @return {Promise}
     */
    setStatus = (actualStatus, newStatus, confirmMessage) => (
        setStatusFunc(this.props, actualStatus, newStatus, confirmMessage)
    )

    /**
     * Render out sportnections request
     *
     * @param user
     * @param text
     * @param squareLook
     * @returns {XML}
     */
    renderRequestOut = (user, text, squareLook) => {
        const { t } = this.props

        return (
            <Button
                className={classnames({
                    'no-focus-outline': true,
                    'u-square d-flex flex-row align-items-center h-100': squareLook,
                    'u-circle': !squareLook,
                })}
                onClick={() => this.setStatus(1, 3, t('removeSportnectionQuestion'))}
            >
                <SnIcon
                    isHoverable={true}
                    className={classnames({
                        'text-color-accent': true,
                        'sn-lg': !squareLook,
                        'sn-md mr-1': squareLook
                    })}
                    notHoverClassName="sn-invitation-circle-empty"
                    hoverClassName="sn-invitation-circle-fill"
                />
                {text}
            </Button>
        )
    }

    /**
     * Render in sportnections request
     *
     * @param user
     * @param text
     * @param squareLook
     * @returns {XML}
     */
    renderRequestIn = (user, text, squareLook) => {
        const { dropdown } = this.state
        const { t } = this.props

        return (
            <Button
                className={classnames({
                    'no-focus-outline': true,
                    'u-circle': !squareLook,
                    'u-square d-flex flex-row align-items-center h-100': squareLook,
                })}
                onClick={() => this.toggleDropdown()}
            >
                <SnIcon
                    isHoverable={true}
                    className={classnames({
                        'sn-lg': !squareLook,
                        'sn-md mr-1': squareLook
                    })}
                    notHoverClassName="sn-hourglass-circle-empty"
                    hoverClassName="sn-hourglass-circle-empty"
                />
                {text}
                {dropdown &&
                    <div className="u-button__attend-menu">
                        <div
                            onClick={() => this.setStatus(1, 2, null)}
                            className="u-button__attend-menu-item"
                        >
                            <div>{t('accept')}</div>
                        </div>
                        <div
                            onClick={() => this.setStatus(1, 3, t('removeSportnectionRequestQuestion'))}
                            className="u-button__attend-menu-item"
                        >
                            <div>{t('decline')}</div>
                        </div>
                    </div>
                }
            </Button>
        )
    }

    /**
     * Render denied request
     *
     * @param user
     * @param text
     * @param squareLook
     * @returns {XML}
     */
    renderRequestDeny = (user, text, squareLook) => {
        const { dropdown } = this.state
        const { t } = this.props

        return (
            <Button
                className={classnames({
                    'no-focus-outline': true,
                    'u-square d-flex flex-row align-items-center h-100': squareLook,
                    'u-circle': !squareLook
                })}
                onClick={() => this.toggleDropdown()}
            >
                <SnIcon
                    isHoverable={true}
                    className={classnames({
                        'sn-lg': !squareLook,
                        'sn-md mr-1': squareLook
                    })}
                    notHoverClassName="sn-cross-circle-empty"
                    hoverClassName="sn-cross-circle-fill"
                />
                {text}
                {dropdown &&
                    <div className="u-button__attend-menu">
                        <div
                            onClick={() => this.setStatus(3, 1, t('requestSportnectionAgainQuestion'))}
                            className="u-button__attend-menu-item"
                        >
                            <div>{t('createRequest')}</div>
                        </div>
                    </div>
                }
            </Button>
        )
    }

    /**
     * Render declined
     *
     * @param user
     * @param text
     * @param squareLook
     * @returns {XML}
     */
    renderDeny = (user, text, squareLook) => {
        const { dropdown } = this.state
        const { t } = this.props

        return (
            <Button
                className={classnames({
                    'no-focus-outline': true,
                    'u-square d-flex flex-row align-items-center h-100': squareLook,
                    'u-circle': !squareLook,
                })}
                onClick={() => this.toggleDropdown()}
            >
                <SnIcon
                    isHoverable={true}
                    className={classnames({
                        'sn-lg': !squareLook,
                        'sn-md mr-1': squareLook
                    })}
                    notHoverClassName="sn-cross-circle-empty"
                    hoverClassName="sn-cross-circle-empty"
                />
                {text}
                {dropdown &&
                    <div className="u-button__attend-menu">
                        <div
                            onClick={() => this.setStatus(4, 1, t('requestSportnectionAgainQuestion'))}
                            className="u-button__attend-menu-item"
                        >
                            <div>{t('createRequest')}</div>
                        </div>
                    </div>
                }
            </Button>
        )
    }

    /**
     * Render in connection
     *
     * @param user
     * @param text
     * @param squareLook
     * @returns {XML}
     */
    renderInConnection = (user, text, squareLook) => {
        const { dropdown } = this.state
        const { t } = this.props

        return (
            <Button
                className={classnames({
                    'no-focus-outline': true,
                    'u-square d-flex flex-row align-items-center h-100': squareLook,
                    'u-circle': !squareLook,
                })}
                onClick={() => this.toggleDropdown()}
            >
                <SnIcon
                    isHoverable={true}
                    className={classnames({
                        'text-color-accent': true,
                        'sn-lg': !squareLook,
                        'sn-md mr-1': squareLook
                    })}
                    notHoverClassName="sn-confirm-circle-empty"
                    hoverClassName="sn-confirm-circle-fill"
                />
                {text}
                {dropdown &&
                    <div className="u-button__attend-menu">
                        <div
                            onClick={() => this.setStatus(1, 4, t('removeSportnectionOfUserQuestion'))}
                            className="u-button__attend-menu-item"
                        >
                            <div>{t('removeSportnection')}</div>
                        </div>
                    </div>
                }
            </Button>
        )
    }

    /**
     * Render friendship status based on status
     *
     * @param user
     * @param squareLook
     * @returns {XML}
     */
    renderFriendshipStatus = (user, squareLook) => {
        const {
            text,
            state,
            friendshipType,
        } = friendshipStateLookup(user)

        const { successCallback } = this.props

        switch (state) {
            case 1:
                if (friendshipType === 'in') {
                    return this.renderRequestIn(user, text, squareLook)
                }
                return this.renderRequestOut(user, text, squareLook)
            case 2:
                return this.renderInConnection(user, text, squareLook)
            case 3:
                return this.renderRequestDeny(user, text, squareLook)
            case 4:
                return this.renderDeny(user, text, squareLook)
            default:
                return (
                    <SportnectionsRequestButton
                        text={text}
                        setStatus={this.setStatus}
                        successCallback={successCallback}
                        squareLook={squareLook}
                    />
                )
        }
    }

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        const {
            user,
            squareLook,
        } = this.props

        return (
            this.renderFriendshipStatus(user, squareLook)
        )
    }
}

export default withRouterConnectWrapper(state => ({
    users: state.users,
}))(wrapperClickOutside(FriendshipStatus, 'dropdown', 'toggleDropdown'))
